<script setup>
/**
 * 服务凭据池：不属模型能力、但同样从平台密钥池租用的凭据——数字人 Vidu（`avatar:vidu`）与实时音视频阿里云 ARTC（`rtc:artc`）。
 * 每个 vendor 一张 KeyPool；两类都没配好时互动小说只是不提供数字人，所以允许停用、删除最后一把。
 */
import { onMounted, ref } from 'vue'
import { Button, Section, Spinner } from '@drama/ui'
import { useI18n } from 'vue-i18n'
import { deleteServiceKey, fetchServiceKeys, saveServiceKey } from '../../../api/model-capabilities.js'
import KeyPool from './KeyPool.vue'

const { t } = useI18n()
const pools = ref([])
const loading = ref(true)
const error = ref('')

onMounted(load)

async function load() {
  loading.value = true
  error.value = ''
  try {
    pools.value = (await fetchServiceKeys()).pools
  } catch (err) {
    error.value = err.message
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <Section
    :title="t('visualGameAdmin.llm.providers.serviceKeys.title')"
    padded
    data-insp-path="apps/visual-game-admin/src/pages/llm/provider/ServiceKeyPools.vue#service-keys"
  >
    <p class="service-keys__hint">
      {{ t('visualGameAdmin.llm.providers.serviceKeys.hint') }}
    </p>
    <div v-if="loading" class="vga-state">
      <Spinner :label="t('visualGameAdmin.common.loading')" />
    </div>
    <div v-else-if="error" class="vga-state">
      <p class="vga-error" role="alert">
        {{ error }}
      </p>
      <Button variant="secondary" @click="load">
        {{ t('visualGameAdmin.common.retry') }}
      </Button>
    </div>
  </Section>

  <KeyPool
    v-for="pool in pools"
    :key="pool.vendor"
    :vendor="pool.vendor"
    :keys="pool.keys"
    :save-key="(body) => saveServiceKey(pool.vendor, body)"
    :delete-key="(keyId) => deleteServiceKey(pool.vendor, keyId)"
    :require-enabled-key="false"
    @changed="load"
  />
</template>

<style scoped>
.service-keys__hint {
  margin: 0;
  color: var(--drama-color-text-muted);
  line-height: var(--drama-line-height-normal);
}
</style>
